'use client'

import React, { useMemo } from 'react'
import { useTranslations, useLocale } from 'next-intl'
import { TopCountries } from './topCountries'
import COUNTRIES_BY_BRAND from '@/src/constants/countries'
import { getBrandName } from '@/src/utils/buildUtils'

export const TopCountriesWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const title = t('countries') || 'Countries'
    const brand = getBrandName()
    const countriesData = COUNTRIES_BY_BRAND[brand]?.countries || []
    
    const isArabic = locale === 'ar'

    const countries = useMemo(() => {
        return countriesData.map(country => ({
            name: isArabic ? country.name_ar || country.name_en : country.name_en,
            href: country.href + `/${locale}`
        }))
    }, [countriesData, isArabic])

    if (!countries || countries.length === 0) {
        return null
    }

    return <TopCountries title={title} countries={countries} />
}

export default TopCountriesWrapper